/**
 * Created by razial on 19.01.2023
 */

cleverapps.UI.animateHintFly = function (target, options) {
    const scene = cleverapps.Scenes.GetRunningScene();
    options = options || {};

    const animation = new cleverapps.Spine(bundles.game.jsons.hint_json);
    animation.setAnimation(0, "animation", false);
    animation.setCompleteListener(() => {
        animation.setAnimation(0, "idle", false);
        animation.setCompleteListenerRemove();
    });
    scene.addChild(animation);

    const targetPos = animation.getRelativeCoordinates(target);

    let startPos;
    if (options.startPosition) {
        startPos = options.startPosition;
    } else {
        startPos = animation.getRelativeCoordinates(options.start ? options.start : cleverapps.aims.getTarget(`boosters${cleverapps.Boosters.TYPE_HINT}`));
    }

    const duration = options.duration || 0.3;
    const distance = cc.pDistance(startPos, targetPos);
    const timescale = Math.min(1, distance / duration / cleverapps.styles.FlyHintAnimation.speed);

    animation.setTimeScale(timescale);
    animation.setLocalZOrder(10);
    animation.setAlignment(startPos);
    animation.setRotation(Math.atan2(targetPos.x - startPos.x, targetPos.y - startPos.y) * 180 / Math.PI);

    animation.runAction(new cc.Sequence(
        cleverapps.effects.fireAction("board.hint"),
        new cc.MoveTo(duration, targetPos),
        new cc.CallFunc(() => {
            animation.setTimeScale(1);
            animation.replaceParentSamePlace(target, {
                keepScale: true
            });
        })
    ));
};

cleverapps.UI.animateLetterHintFly = function (target, letterSprite, options) {
    options = options || {};
    const movingNode = cleverapps.Scenes.GetMovingNode(target);
    movingNode.addChild(letterSprite);
    letterSprite.setScale(1 / cc.Base.AdjustScaleTo(letterSprite, target).x);
    const shine = new cleverapps.Spine(bundles.game.jsons.hint_json);
    shine.setAnimation(0, "idle", false);
    shine.setVisible(false);
    shine.setAnchorPoint(0.5, 0.5);
    shine.setAlignment(letterSprite.width / 2, letterSprite.height / 2);
    shine.setTimeScale(0);
    letterSprite.addChild(shine);

    const targetPos = letterSprite.getRelativeCoordinates(target);

    const persistNode = cleverapps.persist.acceptNode("ScoreBarAvatar", movingNode);
    const source = options.start || persistNode || cleverapps.aims.getTarget(`boosters${cleverapps.Boosters.TYPE_HINT}`);

    const startPos = letterSprite.getRelativeCoordinates(source);

    letterSprite.setAlignment(startPos);

    if (persistNode) {
        persistNode.removeFromParent();
    }

    return new cc.Sequence(
        cleverapps.effects.fireAction("board.hint.letter"),
        new cc.Spawn(
            new cc.Sequence(
                new cc.MoveTo(0.375, targetPos),
                new cc.ReplaceParent(target)
            ),
            new cc.Sequence(
                new cc.RotateTo(0.2, 30).easing(cc.easeOut(1)),
                new cc.RotateTo(0.16, 0).easing(cc.easeIn(1)),
                new cc.Spawn(
                    new cc.CallFunc(() => {
                        shine.setVisible(true);
                        shine.setTimeScale(1);
                    }),
                    new cc.RotateTo(0.14, -30).easing(cc.easeIn(1))
                ),
                new cc.RotateTo(0.125, 0)
            )
        )
    );
};

cleverapps.styles.FlyHintAnimation = {
    speed: 3500
};